import Form from '@utilities/form';
import addAlertMessage from '@utilities/errors/add-alert-message';
import ScrollTo from "@utilities/scroll-to";
import Events from "@utilities/events";
import gtmFooterSubscribeButtonClick from '@utilities/gtmFooterSubscribeButtonClick';
import newsletterConstraints from './newsletter-constraints';

const JS_HOOK_NEWSLETTER_ALERT = '[js-hook-newsletter-alert]';
const JS_HOOK_NEWSLETTER_FORM_FIELDS_WRAPPER = '[js-hook-newsletter-form-fields-wrapper]';
const JS_HOOK_NEWSLETTER_WRAPPER = '[js-hook-newsletter-form-wrapper]';
const JS_HOOK_NEWSLETTER_BUTTON = '[js-hook-newsletter-button]';
const JS_HOOK_NEWSLETTER_TEXT_WRAPPER = '[js-hook-newsletter-text-wrapper]';
const JS_HOOK_CONSENT_ONE = '[js-hook-consent-one]';
const JS_HOOK_CONSENT_TWO = '[js-hook-consent-two]';

const HIDDEN_CLASS = 'u-hidden';
const NEWSLETTER_TEXT_WRAPPER_OPENED = 'is--open'

/**
 * Used to handle newsletter requests from user
 *
 * @class NewsletterForm
 * @extends {Form}
 */
class NewsletterForm extends Form {
  constructor(element) {
    super(element);

    this.messageSelector = JS_HOOK_NEWSLETTER_ALERT;
    this.fieldsWrapper = this.form.querySelector(JS_HOOK_NEWSLETTER_FORM_FIELDS_WRAPPER);
    this.modalId = this.form.dataset.modalId;
    this.newsletterFormWrapper = document.querySelector(JS_HOOK_NEWSLETTER_WRAPPER)
    this.newsletterButton = document.querySelector(JS_HOOK_NEWSLETTER_BUTTON);
    this.newsletterTextWrapper = document.querySelector(JS_HOOK_NEWSLETTER_TEXT_WRAPPER);
    this.consent1 = document.querySelector(JS_HOOK_CONSENT_ONE);
    this.consent2 = document.querySelector(JS_HOOK_CONSENT_TWO);

    // Init constraints
    this.initConstraints();

    // Events: Submit & Change Events
    this._bindEvents();
    this.bindChangeEvents();
    this.bindSubmitEvents();
  }

  _bindEvents() {
    if (this.newsletterButton !== null) {
        this.newsletterButton.addEventListener('click', () => {
        this.newsletterButton.classList.add(HIDDEN_CLASS);
        this.newsletterTextWrapper.classList.add(NEWSLETTER_TEXT_WRAPPER_OPENED);
        this.newsletterFormWrapper.classList.remove(HIDDEN_CLASS);
        }, false);
    }

    if (this.consent1 && this.consent2) {
        this.consent1.addEventListener('change', ()=>{
        if (this.consent1.checked){
            this.consent2.removeAttribute('disabled');
        }else{
            this.consent2.setAttribute('disabled', 'disabled');
            this.consent2.removeAttribute('checked');
        }
        });
    }

    if (this.modalId) {
      Events.$on('modal::opened[newsletter-form-modal]', () => NewsletterForm.updateFields());
    }
  }

  static updateFields() {
    const emailFormField = document.getElementById('dwfrm_newsletter_email');
    const emailPrefillField = document.getElementById('newsletter-email-toggle-field');

    emailFormField.value = emailPrefillField ? emailPrefillField.value : '';
  }

    // Allow second consent only when first is accepted
    updateProfileCheckbox = (clickedEl, affectedEl) => {
        if(clickedEl.target.checked) {
            affectedEl.removeAttribute('disabled');
        } else {
            affectedEl.checked = false;
            affectedEl.setAttribute('disabled', 'disabled');
        }
    }

  /**
   * Init constraints for form validation for validate.js
   */
  initConstraints() {
    this.constraints = newsletterConstraints(this.customValidationMessages);
  }

  afterSubmitFormSuccess({receivedMsgBody, success, userData}) {
    if(receivedMsgBody && success) {
      gtmFooterSubscribeButtonClick(true, userData);
      addAlertMessage({ message: receivedMsgBody, hook: this.messageSelector, type: 'success' });
      this.fieldsWrapper.classList.add(HIDDEN_CLASS);
      this.form.reset();
      this.newsletterTextWrapper.classList.remove(NEWSLETTER_TEXT_WRAPPER_OPENED);

      ScrollTo.scrollTo(this.form, 350, 180);
    }
  }
}

export default NewsletterForm;
